import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnDemandDriversRoutingModule } from './on-demand-drivers-routing.module';
import { OnDemandDriversComponent } from './on-demand-drivers.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { OnDemandDriversService } from './on-demand-drivers.service';
import { EditorModule } from '../A2-utils/editor/editor.module';
import { EditComponent } from './components/edit/edit.component';
import { PersonalInfoComponent } from './components/personal-info/personal-info.component';
import { MyDatePickerModule } from 'mydatepicker';
import { CompaniesService } from '../companies/companies.service';
import { RolesService } from '../roles/roles.service';
import { VehiclesComponent } from './components/vehicles/vehicles.component';
import { VehiclesService } from '../vehicles/vehicles.service';
import { BankInfoComponent } from './components/bank-info/bank-info.component';
import { BackgroundCheckComponent } from './components/background-check/background-check.component';
import { TripHistoryComponent } from './components/trip-history/trip-history.component';
import { LogsComponent } from './components/logs/logs.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { ChangeLogsComponent } from './components/change-logs/change-logs.component';
import { DeleteComponent } from './components/delete/delete.component';
import { DirectivesModule } from '../../directives/directives.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { UserDeviceComponent } from './components/user-device/user-device.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { TextMaskModule } from 'angular2-text-mask';
import { SsnModuleModule } from '../../utils/ssn-module/ssn-module.module'
import { DeviceInformationModule } from '../A2-utils/device-information/device-information.module';
import { SendMessageModule } from 'app/utils/send-message/send-message.module';
import { ValidateVINModule } from '../A2-utils/validate-vin/validate-vin.module';
import { GenericReportingService } from 'app/core/services/genericReporting.service';
import { DriverBackgroundCheckModule } from '../../utils/driver-background-check/driver-background-check.module';
import { DriverBackgroundCheckApiService } from '../../utils/driver-background-check/driver-background-check-api.service';
import { UpdateDriversScheduleModule } from 'app/utils/update-drivers-schedule/update-drivers-schedule.module';
import { T2AutoCompleteLocationModule } from '../A2-utils/t2-autocomplete-location/t2-autocomplete-location.module';
import { ChangePasswordModule } from '../A2-utils/change-password/change-password.module';
import { ProgressBarCellComponent } from '../A2-utils/grid-components/progress-bar-cell/progress-bar-cell.component';
import { CoursesModuleComponent } from './components/courses-module/courses-module.component';
import { BarcodeScannerModule } from '../../utils/barcode-scanner/barcode-scanner.module';
import { UsersService } from '../users/users.service';

@NgModule({
    imports: [
        CommonModule,
        Trip2ThemeModule,
        FormsModule,
        AgGridModule.withComponents([BooleanCheckComponent, ProgressBarCellComponent]),
        GridComponentsModule,
        EditorModule,
        MyDatePickerModule,
        OnDemandDriversRoutingModule,
        DirectivesModule,
        MyDateRangePickerModule,
        TextMaskModule,
        SsnModuleModule,
        DeviceInformationModule,
        ReactiveFormsModule,
        SendMessageModule,
        ValidateVINModule,
        UpdateDriversScheduleModule,
        T2AutoCompleteLocationModule,
        ChangePasswordModule,
        BarcodeScannerModule,
        DriverBackgroundCheckModule
    ],
  declarations: [
    OnDemandDriversComponent,
    EditComponent,
    PersonalInfoComponent,
    VehiclesComponent,
    BankInfoComponent,
    BackgroundCheckComponent,
    TripHistoryComponent,
    LogsComponent,
    DocumentsComponent,
    ChangeLogsComponent,
    DeleteComponent,
    UserDeviceComponent,
    CoursesModuleComponent
  ],
    exports: [
        OnDemandDriversComponent,
        BackgroundCheckComponent,
        CoursesModuleComponent
    ],
  providers: [OnDemandDriversService,
    CompaniesService,
    RolesService,
    VehiclesService,
    GenericReportingService,
    UsersService,
    DriverBackgroundCheckApiService
  ]
})
export class OnDemandDriversModule { }



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/on-demand-drivers.module.ts